import type { SVGProps } from 'react';
import styles from './Spinner.module.css';

export type SpinnerProps = SVGProps<SVGSVGElement> & {
  size: number;
};

export const Spinner = ({ size, className, ...props }: SpinnerProps) => {
  return (
    <svg
      aria-label="Loading..."
      className={`${styles.spinner} ${className ?? ''}`}
      data-test-id="spinner"
      fill="none"
      height={size}
      viewBox="0 0 48 48"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Loading...</title>
      <rect fill="#F6F6F9" height="12" rx="2" width="4" x="22" />
      <rect fill="#F6F6F9" height="12" rx="2" width="4" x="22" y="36" />
      <rect
        fill="#F6F6F9"
        height="12"
        rx="2"
        transform="rotate(-90 0 26)"
        width="4"
        y="26"
      />
      <rect
        fill="#F6F6F9"
        height="12"
        rx="2"
        transform="rotate(-90 36 26)"
        width="4"
        x="36"
        y="26"
      />
      <rect
        fill="#F6F6F9"
        height="12"
        rx="2"
        transform="rotate(-45 5.61523 8.4436)"
        width="4"
        x="5.61523"
        y="8.4436"
      />
      <rect
        fill="#F6F6F9"
        height="12"
        rx="2"
        transform="rotate(-45 31.0703 33.8994)"
        width="4"
        x="31.0703"
        y="33.8994"
      />
      <rect
        fill="#F6F6F9"
        height="12"
        rx="2"
        transform="rotate(-135 8.44336 42.3848)"
        width="4"
        x="8.44336"
        y="42.3848"
      />
      <rect
        fill="#F6F6F9"
        height="12"
        rx="2"
        transform="rotate(-135 33.8984 16.9287)"
        width="4"
        x="33.8984"
        y="16.9287"
      />
    </svg>
  );
};
